function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#231F20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M17.5,1h-11C5.897,1,5,1.402,5,2.509v0.183L2.255,3.179C1.66,3.285,0.843,3.82,1.026,4.862l2.27,12.951 c0.01,0.059,0.074,0.37,0.303,0.664C3.867,18.82,4.25,19,4.699,19c0.104,0,0.211-0.01,0.322-0.029l4.878-0.866H17.5 c0.603,0,1.5-0.402,1.5-1.509V2.509C19,1.903,18.601,1,17.5,1z M4.847,17.98c-0.318,0.055-0.508-0.061-0.567-0.342L2.01,4.687 C1.947,4.323,2.248,4.206,2.428,4.169L5,3.713v12.882c0,0.404,0.183,0.934,0.627,1.246L4.847,17.98z M18,16.596 c0,0.405-0.275,0.497-0.5,0.503h-11c-0.403,0-0.494-0.277-0.5-0.503V2.509c0-0.404,0.273-0.497,0.504-0.503H17.5 c0.402,0,0.494,0.277,0.5,0.503V16.596z"
});

function SvgFlashCards1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashCards1);
export default __webpack_public_path__ + "static/media/flash_cards_1.00a696f7.svg";
export { ForwardRef as ReactComponent };